import { createMuiTheme } from '@material-ui/core/styles';

export default createMuiTheme({
  typography: {
    fontSize: 12,
    fontFamily: 'Open Sans, sans-serif'
  },
  palette: {
    primary: {
      light: '#2c9bc3',
      main: '#2c9bc3',
      dark: '#2c9bc3',
      contrastText: '#fff',
    }
  }
});

export const tableStyles = {
  table: {
    tableLayout: 'fixed',
    typography: {
      fontSize: '12px',
      htmlFontSize: '12px'
    },
    // border: '1px dashed #d1d1d1',
  },
  tbody: {
    height: 'inherit'
  },
  headerCell: {
    backgroundColor: '#606060',
    // borderLeft: '1px dashed #d1d1d1',
    // borderTop: '1px dashed #d1d1d1',
    // borderBottom: '1px dashed #d1d1d1',
    color: '#fff',
    height: '20px',
    paddingTop: 0,
    paddingLeft: '8px',
    fontSize: '12px',
    fontFamily: 'Open Sans',
    fontWeight: 500,
    '&:last-child': {
      paddingLeft: '8px'
    }
  },
  checkbox: {},
  row: {
    paddingTop: '5px',
    paddingBottom: '5px',
    lineHeight: '17px',
    maxHeight: '60px',
    height: '35px'
  },
  rowEven: {
    background: '#FFf'
  },
  rowOdd: {
    background: '#F0F0F0'
  },
  rowCell: {
    padding: '4px 8px',
    whiteSpace: 'normal',
    // borderLeft: '1px dashed #d1d1d1',
    overflow: 'hidden',
    // borderTop: '1px dashed #d1d1d1',
    // borderBottom: '1px dashed #d1d1d1',
    width: '35px'
  }
};



// WEBPACK FOOTER //
// ./src/stylization/SecretarTheme.js